<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <notifications group="pwdreset" position="top center">
        <template #body="props">
          <b-alert :variant="props.item.type" show class="m-2 text-center">{{
            props.item.text
          }}</b-alert>
        </template>
      </notifications>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Redefinir senha</h1>
                  <p class="text-muted">Digite sua nova senha</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text
                        ><i class="fa-solid fa-unlock" aria-hidden="true"></i
                      ></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      id="password"
                      v-model="password"
                      type="password"
                      class="form-control"
                      placeholder="Nova Senha"
                      @keyup="checkStrength"
                      @keyup.native="checkSubmit"
                    >
                    </b-form-input>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text
                        ><i class="fa-solid fa-unlock" aria-hidden="true"></i
                      ></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="confirmPassword"
                      type="password"
                      class="form-control"
                      placeholder="Confirmar Senha"
                      @keyup.native="checkSubmit"
                    >
                    </b-form-input>
                  </b-input-group>
                  <b-progress
                    :value="passwordScore"
                    max="4"
                    class="mb-1"
                    animated
                    :variant="scoreVariant"
                  />
                  <b-row v-if="pwdErrors" class="mb-2">
                    <b-col cols="12">
                      <span class="text-danger">{{ pwdErrors }}</span>
                    </b-col>
                  </b-row>
                  <b-popover
                    target="password"
                    triggers="manual blur"
                    placement="top"
                  >
                    <template #title>Sugestões</template>
                    <span>
                      <template v-for="(suggestion, idx) in suggestions"
                        ><span :key="suggestion"
                          >{{ suggestion }}<br v-if="idx > 0"
                        /></span>
                      </template>
                    </span>
                  </b-popover>
                  <b-row>
                    <b-col cols="5">
                      <b-button
                        v-show="!linkExpired"
                        variant="primary"
                        :disabled="loading || passwordScore < 3"
                        class="px-4"
                        @click="handleSubmit"
                        >Confirmar
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-white py-5 d-md-down-none"
              style="width: 44%"
            >
              <b-card-body class="text-center">
                <img
                  alt="Logo Admin"
                  :src="logo"
                  style="max-width: 50%; object-fit: contain"
                />
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import sha256 from "js-sha256";
import { resetPassword } from "@/api/user";
import zxcvbn from "zxcvbn";
import messages from "@/i18n/zxcvbn.json";
import { mapGetters } from "vuex";

export default {
  name: "ResetPassword",
  props: {
    hash: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pwdErrors: "",
      suggestions: [],
      password: "",
      confirmPassword: "",
      loading: false,
      linkExpired: false,
      passwordScore: 0,
    };
  },
  computed: {
    ...mapGetters(["appSettings", "portalBucket"]),
    logo() {
      if (this.appSettings?.whitelabel) {
        return `https://${this.portalBucket}/${this.appSettings?.whitelabel.logo}`;
      }
      return "img/logo-gestao.png";
    },
    scoreVariant() {
      switch (this.passwordScore) {
        case 4:
        case 3:
          return "success";
        case 2:
          return "warning";
        default:
          return "danger";
      }
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        await resetPassword(this.hash, sha256(this.password));
        this.loading = false;
        this.$router.push({ path: "/" });
      } catch (error) {
        this.loading = false;
        if (parseInt(error.response.status / 100) === 4) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
    checkSubmit(e) {
      if (e.key === "Enter") {
        this.handleSubmit();
      }
    },

    checkStrength() {
      const result = zxcvbn(this.password);
      this.passwordScore = result.score;
      this.pwdErrors = messages[result?.feedback?.warning] || "";
      const suggestions = [];
      for (const suggestion of result?.feedback?.suggestions || []) {
        suggestions.push(messages[suggestion]);
      }
      this.suggestions = suggestions;
      if (this.suggestions.length > 0 && this.password) {
        this.$root.$emit("bv::show::popover");
      }
    },

    async handleSubmit() {
      this.pwdErrors = "";

      if (this.password !== this.confirmPassword) {
        this.pwdErrors = "As senhas não conferem";
        return;
      } else if (this.password.length === 0) {
        this.pwdErrors = "Preencha os campos";
        return;
      }
      await this.submit();
    },
  },
};
</script>
